export default __webpack_public_path__ + "static/ISO-IEC-2f96e111e7a77d8722167e0f2617e22b.png";